import {AjaxRequest} from "../ajax-request";
import {Modal} from '../modal.js';
import {ErrorMsg} from '../error_model'
import {togglePassword} from "../passwordToggle";
import * as translation from "../translations";

const errors = new ErrorMsg().errorsCode;
const ajaxRequest = new AjaxRequest();
const modal = new Modal();
const spinner = document.querySelector('.spinner');
const action = document.querySelector('section.form').getAttribute('data-action');

togglePassword('#password_toggle');
$(document).ready(function () {
    $.validator.addMethod("strongPassword", function (value, element) {
        return this.optional(element) || /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(value);
    }, translation.translations[translation.lang].strongPassword);


    $('#password_form').validate({
        rules: {
            oldPassword: {
                required: true
            },
            password: {
                strongPassword: true,
                required: true,
            },
            repeatPassword: {
                strongPassword: true,
                required: true,
                equalTo: '#password'
            }
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.addClass('error-message');
            error.insertAfter(element);
        },
        messages: {
            oldPassword: {
                required: translation.translations[translation.lang].required,
            },
            password: {
                required: translation.translations[translation.lang].required,
            },
            repeatPassword: {
                required: translation.translations[translation.lang].required,

            },

        },
        submitHandler: function (form, event) {
            let data = {}
            $(form).serializeArray().forEach(obj => {
                data[obj.name] = obj.value
            })
            resetPassword(data).then(res => {

                if (res['data']?.errors) {
                    let code = res['data']['errors'][0]['responseCode'];
                    debugger
                    if (errors[code.trim()]) {
                        modal.show(errors[code.trim()])
                    } else {
                        modal.show(translation.translations[translation.lang].sendError);
                    }
                } else if (res['success']) {
                    $('#password_form')[0].reset();
                    modal.show(translation.translations[translation.lang].changePasswordSuccess);
                    //  window.location.href = '/profil/' + (translation.lang !== 'pl' ? '_' + translation.lang : '');

                }
            })
        }
    });
});


async function resetPassword(data) {
    spinner.style.display = "flex"
    try {
        let response = await ajaxRequest.request(action, data);
        spinner.style.display = "none"
        return response
    } catch (error) {
        spinner.style.display = "none"
        return error

    }
}














